<template>
    <div>
        <span class="open">
            <span class="material-icons">expand_more</span>
        </span>
        <span class="close">
            <span class="material-icons">expand_less</span>
        </span>
    </div>
</template>

<script>
export default {
    name: 'vsa-custom-icon',
};
</script>

<style lang="scss" scoped>
.vsa-item {
    .vsa-item__trigger__icon .material-icons {
        font-size: 2.5em;
    }

    &--is-active {
        .vsa-item__trigger__icon {
            .open {
                display: none;
            }
            .close {
                display: block;
            }
        }
    }

    &__trigger__icon {
        .open {
            display: block;
        }
        .close {
            display: none;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/VsaCustomIcon.vue